import { shade } from 'polished';
import styled from 'styled-components';

export const Container = styled.div`

  height: 100vh;

  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const Content = styled.div`
  background:#fafafa;

  display:flex;
  align-items:center;
  justify-content:center;
`;

export const NavMenu = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ContentContainer = styled.div`
  display:flex;

  flex-direction: column;
  padding: 3rem;
  background: #fff;
  border: 1px solid #eee;
  max-width: 1050px;
  width: 100%;
  margin: 3rem 0;

  h1 {
    text-align: center;
    margin-bottom:2rem;
    color: var(--yellow);
  }

  h3 {
    margin-top:2rem;
    font-weight: 700;
    color: #999;
  }

  .div_agroup {
      display: flex;
      flex-direction: row;
      width: 100%;

      > div{
        flex: 1;
        margin-right: 1rem;
        margin-left: 1rem;
      }

      > div:first-child{
        margin-left: 0;
      }

      > div:last-child{
        margin-right: 0;
      }
    }

  .select_component{
    background: #f6f6f6;
    border: 2px solid #f6f6f6;
    margin-top: 0.5rem;
  }

  .label_select{
    color: #343434;
  }
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  a{
    background: var(--light-black);
    color: #fff;
    padding: 1rem 2rem;
    font-weight: 700;
  }

  a:hover{
    background: var(--yellow);
  }
`;


export const AvatarInputContainer = styled.div`
  margin-bottom: 32px;
  align-self: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  .placeholder-avatar {
    width: 186px;
    height: 186px;
    border-radius: 50%;
    background: #ccc;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 1.2rem;
    border: 4px solid #f4ede8;
  }

  label {
    width: 48px;
    height: 48px;
    background: #f59e0b;
    border-radius: 50%;
    cursor: pointer;
    transition: background-color 0.2s;
    margin-top: -32px;

    display: flex;
    align-items: center;
    justify-content: center;

    input {
      display: none;
    }

    svg {
      width: 20px;
      height: 20px;
      color: #312e38;
    }

    &:hover {
      background: ${shade(0.2, '#f59e0b')};
    }
  }

  button, a {
    width: 48px;
    height: 48px;
    background: #f59e0b;
    border-radius: 50%;
    cursor: pointer;
    transition: background-color 0.2s;
    margin-top: -32px;
    border: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    input {
      display: none;
    }

    svg {
      width: 20px;
      height: 20px;
      color: #312e38;
    }

    &:hover {
      background: ${shade(0.2, '#f59e0b')};
    }
  }

  .div-crop-existing-button{
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    height: 48px;
    width: 100%;
    margin: 0 auto;
  }
`;
